<div class="recap-container" *ngIf="!loading; else loader">
  <div class="recap-header">
    <h2>Mon livrable en construction</h2>
    <p class="subtitle">
      Récapitulatif de vos réponses pour la génération de votre livrable personnalisé.
    </p>
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="(answeredCount / totalCount) * 100"></div>
    </div>
    <p class="progress-text">{{ answeredCount }} / {{ totalCount }} module{{ totalCount > 1 ? 's' : '' }} complété{{ answeredCount > 1 ? 's' : '' }}</p>
  </div>

  <div *ngIf="generatedDeliverable?.status === 'pending'" class="generation-pending">
    <div class="loader-icon"></div>
    <h3>Génération en cours...</h3>
    <p>Votre livrable est en cours de création. Vous pouvez quitter cette page, la génération continue en arrière-plan.</p>
    <p class="hint">La page se mettra à jour automatiquement une fois la génération terminée.</p>
  </div>

  <div *ngIf="generatedDeliverable?.status === 'failed'" class="generation-failed">
    <div class="error-icon">✕</div>
    <h3>La génération a échoué</h3>
    <p>Une erreur s'est produite lors de la génération. Veuillez réessayer.</p>
    <button (click)="resetAndRetry()" class="btn btn-primary">Réessayer</button>
  </div>

  <div *ngIf="generatedDeliverable?.status === 'completed'" class="already-generated">
    <div class="success-icon">✓</div>
    <h3>Votre livrable a déjà été généré</h3>
    <p>Généré le {{ generatedDeliverable.generatedAt | date:'dd/MM/yyyy à HH:mm' }}</p>
    <div class="generated-actions">
      <button (click)="downloadPdf()" class="btn btn-primary" [disabled]="!generatedDeliverable.pdfUrl">
        Télécharger le PDF
      </button>
      <button (click)="copyGammaLink()" class="btn btn-secondary">
        {{ linkCopied ? 'Lien copié !' : 'Copier le lien Gamma' }}
      </button>
    </div>
  </div>

  <div *ngIf="generatedDeliverable && !generatedDeliverable.status" class="already-generated">
    <div class="success-icon">✓</div>
    <h3>Votre livrable a déjà été généré</h3>
    <p>Généré le {{ generatedDeliverable.generatedAt | date:'dd/MM/yyyy à HH:mm' }}</p>
    <div class="generated-actions">
      <button (click)="downloadPdf()" class="btn btn-primary" [disabled]="!generatedDeliverable.pdfUrl">
        Télécharger le PDF
      </button>
      <button (click)="copyGammaLink()" class="btn btn-secondary">
        {{ linkCopied ? 'Lien copié !' : 'Copier le lien Gamma' }}
      </button>
    </div>
  </div>

  <div class="modules-list" *ngIf="!generatedDeliverable || generatedDeliverable?.status === 'failed'">
    <div *ngFor="let status of moduleStatuses" class="module-item" [class.answered]="status.isAnswered">
      <div class="module-status">
        <span *ngIf="status.isAnswered" class="status-icon answered">✓</span>
        <span *ngIf="!status.isAnswered" class="status-icon pending">○</span>
      </div>
      <div class="module-info">
        <h4>{{ status.module.name }}</h4>
        <p *ngIf="status.isAnswered">Réponses enregistrées</p>
        <p *ngIf="!status.isAnswered" class="pending-text">Non répondu</p>
      </div>
      <div class="module-actions">
        <app-button
          *ngIf="status.isAnswered"
          [outlined]="true"
          text="Modifier"
          size="sm"
          (onClick)="goToModule(status)"
        ></app-button>
        <app-button
          *ngIf="!status.isAnswered"
          text="Répondre"
          size="sm"
          (onClick)="goToModule(status)"
        ></app-button>
      </div>
    </div>
  </div>

  <div class="generation-section" *ngIf="!generatedDeliverable || generatedDeliverable?.status === 'failed'">
    <div class="style-selector">
      <label for="imageStyle">Style des images IA :</label>
      <select id="imageStyle" [(ngModel)]="selectedImageStyle">
        <option *ngFor="let style of imageStyles" [value]="style.value">{{ style.label }}</option>
      </select>
    </div>

    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <div class="generate-action">
      <app-button
        [disabled]="!isAllAnswered || isGenerating"
        [text]="isGenerating ? 'Génération en cours...' : 'Générer mon livrable'"
        theme="info"
        size="md"
        (onClick)="generateDeliverable()"
      ></app-button>
      <p *ngIf="!isAllAnswered" class="warning-text">
        Vous devez répondre à toutes les questions avant de pouvoir générer votre livrable.
      </p>
      <p *ngIf="isAllAnswered && !isGenerating" class="info-text">
        La génération est définitive. Assurez-vous que vos réponses sont complètes.
      </p>
    </div>
  </div>
</div>

<ng-template #loader>
  <app-loader></app-loader>
</ng-template>
